import { FC } from "react";
import SpinnerContainer from "./styles/SpinnerContainer.styled";
import StyledSpinner from "./styles/StyledSpinner.styled";

const Spinner: FC = () => {
  return (
    <SpinnerContainer>
      <StyledSpinner />
    </SpinnerContainer>
  );
};

export default Spinner;
